module.exports = __webpack_public_path__ + "static/media/acessar_rnds.58315427.gif";